module.exports = __webpack_public_path__ + "img/8.b883d14c.jpg";